<template>
	<div class="party_detail">
		<div class="party_pc" v-if="!isPhone">
			<div class="pd_tit">{{ detail.title }}</div>
			<zihao v-if="detail.addtime" :atime="detail.addtime" @font-size="fontSize"></zihao>
			<div class="prt_info img_auto" :style="{ fontSize: zihao + 'px !important',backgroundColor: bgcolor }" style="line-height: 2 !important;"
				v-if="detail.content" v-html="detail.content">
			</div>
			<div class="pdf_box" v-if="fileArr.length">
				<div class="mt_10" v-for="(item,index) in fileArr" :key="index">
					<vue-office-pdf v-if="item.type=='pdf'" :src="item.src" />
					<!-- <vue-office-docx v-if="item.type=='docx'" :src="item.src" /> -->
				</div>
			</div>
			<div class="fj_box">
				<div class="fj_item flex3" v-for="(item,index) in fileArr" :key="index">
					<span>附件{{index+1}}：{{item.name}}</span>
					<span class="ml_15" @click="yuLan(item)">预览</span>
					<span class="ml_15" @click="xiaZai(item)">下载</span>
				</div>
			</div>
			<upnext :updata="updata" :nextdata="nextdata" atpage="infodisclo"></upnext>
		</div>
		<div class="party_ph" v-if="isPhone">
			<div class="pd_tit">{{ detail.title }}</div>
			<div style="padding: 0 0.35rem;">
				<zihao v-if="detail.addtime" :atime="detail.addtime" @font-size="fontSize"></zihao>
			</div>
			<div class="prt_info" :style="{ fontSize: zihao2 + 'rem !important',backgroundColor: bgcolor }" style="line-height: 2 !important;"
				v-if="detail.content" v-html="detail.content">
			</div>
			<div class="pdf_box" v-if="fileArr.length">
                <div class="mt_10" v-for="(item,index) in fileArr" :key="index">
					<vue-office-pdf v-if="item.type=='pdf'" :src="item.src" />
					<!-- <vue-office-docx v-if="item.type=='docx'" :src="item.src" /> -->
				</div>
			</div>
			<div class="fj_box" v-if="fileArr.length">
				<div class="fj_item flex3" v-for="(item,index) in fileArr" :key="index">
					<span>附件{{index+1}}：{{item.name}}</span>
					<span class="ml_15" style="width: 1rem;" @click="yuLan(item)">预览</span>
					<span class="ml_15" style="width: 1rem;" @click="xiaZai(item)">下载</span>
				</div>
			</div>
			<upnext :updata="updata" :nextdata="nextdata" atpage="infodisclo"></upnext>
		</div>
	</div>
</template>

<script>
import VueOfficePdf from '@vue-office/pdf';
import VueOfficeDocx from '@vue-office/docx';
export default {
	components: {
		VueOfficePdf,
		VueOfficeDocx,
	},
	data() {
		return {
			id: '',
			detail: {},
			staticImg: this.$staticImg,
			isPhone: this.$isMobile,
			// pdfsrc: 'https://xwzc.kaishang.top/jie/ceshi.pdf',
			// wordsrc: 'https://xwzc.kaishang.top/jie/fanhui.docx',
			updata: {},
			nextdata: {},
			zihao: 16,
			zihao2: 0.39,
            fileArr: [],
            bgcolor:'#fcfcfc',
		}
	},
	watch: {
		$route(to, from) {
			if (to.path == "/infoDisclosure/infoDetail") {
				this.detail = {};
				this.updata = {};
				this.nextdata = {};
				this.id = this.$route.query.id;
                this.fileArr = [];
				this.messagedt();
			}
		},
	},
	created() {
		this.id = this.$route.query.id;
        this.fileArr = [];
		this.messagedt();
	},
	methods: {
		// 招聘详情
		async messagedt() {
			const res = await this.$api.messagedt({
				id: this.id
			});
			if (res.code == 1) {
                // console.log('信息公开详情',res)
				this.detail = res.data.mess;
				this.updata = res.data.up;
				this.nextdata = res.data.next;
                if(this.detail.color){
                    this.bgcolor = this.detail.color;
                }
                this.detail.content = this.detail.content.replace(
					/<img[^>]*src=['"]([^'"]*)['"][^>]*>/g,
					match => match.replace(/(<img)/, '$1 referrerpolicy="no-referrer"')
				);
				if (this.detail.file) {
					var arr1 = this.detail.file.split(',');
					var arr2 = this.detail.filename.split(',');
					for (let i = 0; i < arr1.length; i++) {
						for (let j = 0; j < arr1.length; j++) {
							if (i == j) {
								this.fileArr.push({
									src: this.$staticImg + arr1[i],
									name: arr2[j],
									type: this.getFileType(arr1[i])
								})
							}
						}
					}
				}
			}
		},
		// renderedHandler() {
		// 	console.log("渲染完成")
		// },
		// errorHandler() {
		// 	console.log("渲染失败")
		// },
		fontSize(e) {
			if (this.isPhone) {
				this.zihao2 = e;
			} else {
				this.zihao = e;
			}
		},
		getFileType(url) {
			const extMatch = url.match(/\.([^./?#]+)(?:[?#]|$)/i);
			const ext = extMatch ? extMatch[1].toLowerCase() : '';

			if (ext === 'pdf') return 'pdf';
			if (ext === 'docx') return 'docx';
			return 'unknown';
		},
        yuLan(item) {
			if (item.type == 'pdf') {
				window.open(item.src, '_blank');
			}
			if (item.type == 'docx') {
				const officeUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(item.src)}`;
				window.open(officeUrl, '_blank', 'width=1920,height=1080');
			}
		},
		xiaZai(item) {
			const fileUrl = item.src;
			const fileName = item.name;
			const link = document.createElement('a');
			link.href = fileUrl;
			link.setAttribute('download', fileName);
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		},
	}
}
</script>

<style lang="scss" scoped>
.party_detail {
	.pdf_box {
		width: 100%;
		height: auto;
	}
	// ::v-deep .vue-office-pdf-wrapper {
	// 	background-color: #fff !important;
	// }
	// ::v-deep .vue-office-docx-wrapper {
	// 	background-color: #fff !important;
	// }
}
</style>